import confirm from './confirm.vue';

export default function(msg, options = {}) {
    this.$overlay(confirm, { ...options, msg }).open();
}
